import { useMemo } from "react";
import dayjs from "dayjs";

export const useTaskDuration = (task) => {
  // Продолжительность задачи в днях
  const taskDurationDays = useMemo(() => {
    if (!task?.start_date || !task?.due_date) {
      return 0;
    }

    const startDate = dayjs(task.start_date);
    const endDate = dayjs(task.due_date);

    // Добавляем 1, чтобы включить оба дня (начальный и конечный)
    return endDate.diff(startDate, "day") + 1;
  }, [task]);

  // Продолжительность задачи в рабочих днях
  const taskDurationWorksDays = useMemo(() => {
    if (!task?.start_date || !task?.due_date) {
      return 0;
    }

    const startDate = dayjs(task.start_date);
    const endDate = dayjs(task.due_date);
    let workDays = 0;
    let currentDate = startDate;

    // Перебираем все дни от начальной до конечной даты включительно
    while (
      currentDate.isBefore(endDate) ||
      currentDate.isSame(endDate, "day")
    ) {
      const dayOfWeek = currentDate.day(); // 0 = Воскресенье, 1 = Понедельник, ..., 6 = Суббота

      // Считаем рабочими днями понедельник (1) - пятницу (5)
      if (dayOfWeek >= 1 && dayOfWeek <= 5) {
        workDays++;
      }

      currentDate = currentDate.add(1, "day");
    }

    return workDays;
  }, [task]);

  return {
    taskDurationDays,
    taskDurationWorksDays,
  };
};
